import React from 'react';
import { Button } from '@chakra-ui/react';

import { DateObj, RenderProps } from 'dayzed';

import { DatepickerProps } from '../utils/commonTypes';

interface DayOfMonthProps extends DatepickerProps {
  renderProps: RenderProps;
  isInRange?: boolean | null;
  dateObj: DateObj;
  onMouseEnter?: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

export const DayOfMonth: React.FC<DayOfMonthProps> = ({
  dateObj,
  propsConfigs,
  isInRange,
  renderProps,
  onMouseEnter,
}) => {
  const { date, selected, selectable, today } = dateObj;
  const { getDateProps } = renderProps;
  const { selectedBg, ...customBtnProps } =
    propsConfigs?.dayOfMonthBtnProps || {};
  let bg = selected || isInRange ? 'blue' || 'blue.100' : 'transparent';
  bg = !selectable ? customBtnProps?.disabledBg || 'red.200' : bg;
  const halfGap = 0.125; // default Chakra-gap-space-1 is 0.25rem
  return (
    <Button
      {...getDateProps({
        dateObj,
        disabled: !selectable,
        onMouseEnter,
      })}
      disabled={!selectable}
      size='sm'
      variant='outline'
      color={selected || isInRange ? 'white' : 'black'}
      fontWeight='regular'
      bg={bg}
      _hover={{
        bg: 'blue.100',
        color: 'blue',
      }}
      // this intends to fill the visual gap from Grid to improve the UX
      // so the button active area is actually larger than when it's seen
      _after={{
        content: "''",
        position: 'absolute',
        top: `-${halfGap}rem`,
        left: `-${halfGap}rem`,
        bottom: `-${halfGap}rem`,
        right: `-${halfGap}rem`,
        borderWidth: `${halfGap}rem`,
        borderColor: 'transparent',
      }}
      {...customBtnProps}
      borderColor={
        today ? customBtnProps?.borderColor || 'blue.100' : 'transparent'
      }
    >
      {selectable ? date.getDate() : 'X'}
    </Button>
  );
};
